export const MESSAGE_TYPES = {
  TEXT: 'text',
  PICTURE: 'picture',
  SYSTEM: 'system',
};
